/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_SettingsInputs */

const en_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const fr_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const de_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

const it_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni`)
};

const ru_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки`)
};

const es_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustes`)
};

const zh_cn2_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置`)
};

const ja_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定`)
};

const hi_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स`)
};

const pt_pt2_event_group_options_settings = /** @type {(inputs: Event_Group_Options_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Event_Group_Options_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_settings = /** @type {((inputs?: Event_Group_Options_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_settings(inputs)
	if (locale === "de") return de_event_group_options_settings(inputs)
	if (locale === "it") return it_event_group_options_settings(inputs)
	if (locale === "ru") return ru_event_group_options_settings(inputs)
	if (locale === "es") return es_event_group_options_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_settings(inputs)
	if (locale === "ja") return ja_event_group_options_settings(inputs)
	if (locale === "hi") return hi_event_group_options_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_settings(inputs)
	return en_event_group_options_settings(inputs)
});